<template>
	<div class="combination-composer">
		<div class="cc-comb-preview">
			<div v-for="(option, index) in currentComb" :key="option.key"
				class="cc-option hl-hover-danger"
				@click="currentComb.splice(index, 1); currentComb = [ ... currentComb ]"
			>
				<img v-if="option.icon" v-lazy="iconURL(option.icon)">
				<span v-else>{{ option.key }}</span>
			</div>
			<div v-for="index in maxCombination - currentComb.length" :key="index"
				class="cc-option empty"
			/>
		</div>
		<div class="cc-comb-arrow">
			<span class="material-icons">arrow_left</span>
		</div>
		<div class="cc-option-list" :class="{ disabled: currentComb.length == maxCombination }">
			<div class="cc-option hl-hover" v-for="option in options" :key="option.key"
				@click="currentComb = [...currentComb, option ]"
			>
				<img v-if="option.icon" v-lazy="iconURL(option.icon)">
				<span v-else>{{ option.key }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'combination-composer',
	props: {
		modelValue: {
			type: Array,
			required: true
		},
		maxCombination: {
			type: Number,
			required: true
		},
		options: {
			type: Array,
			required: true
		}
	},
	computed: {
		currentComb: {
			get() {
				return this.modelValue.map(k => this.options.find(o => o.key === k));
			},
			set(value) {
				this.$emit('update:modelValue', value.map(v => v.key));
			}
		}
	},
	methods: {
		iconURL(pathToIcon) {
			return `https://static.wikia.nocookie.net/rockman_x_dive/images${pathToIcon}`;
		}
	}
};
</script>

<style lang="scss">
.combination-composer {
	display: grid;
	grid-template-columns: 0.8fr 18px 1fr;
	width: 100%;
	.cc-comb-preview,
	.cc-option-list {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(25px, 1fr));
		grid-gap: 1px;
    border-radius: 10px;
    border: 1px solid #fff3;
		background-color: #fff3;
		overflow: hidden;
	}
	.cc-comb-preview {
		grid-template-rows: repeat(auto-fill, minmax(25px, 1fr));
	}
	.cc-comb-arrow {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.cc-option-list {
    height: fit-content;
		transition: filter ease-out 150ms;
		filter: grayscale(0);
		&.disabled {
			pointer-events: none;
			filter: grayscale(1);
			.cc-option {
				cursor: default;
			}
		}
	}
	.cc-option {
		cursor: pointer;
		display: flex;
    align-items: center;
    justify-content: center;
		width: 100%;
		height: 28px;
    background: #424242;
		>img {
			width: 25px;
			height: 25px;
		}
		&.empty {
			cursor: default;
		}
	}
}
</style>
